import { render, staticRenderFns } from "./PresentView.vue?vue&type=template&id=dfc90d90&scoped=true&"
import script from "./PresentView.vue?vue&type=script&lang=js&"
export * from "./PresentView.vue?vue&type=script&lang=js&"
import style0 from "./PresentView.vue?vue&type=style&index=0&id=dfc90d90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc90d90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
